import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//DND
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from "styled-components";

const DragItem = styled.div`
  padding: 0 20px 0 0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background: white;
  margin: 0 0 6px 0;
  flex-direction: row;
  min-height: 64px;
`;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 860,
  maxHeight: 692,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 2,
  textAlign: 'center',
  overflowY: 'auto',
  //maxHeight: '80%'
};

export default function MultipleLinkChips({ onUpdate, index, widget }) {

  const maxChips = 12;
  const defaultChips = { title: '', chips: [{ text: '', url: '', in_evidence: false, }] };
  const isInModification = widget[0]?.data && Object.keys(widget[0]?.data)?.length > 0;

  //Mui Modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  //const handleClose = () => setOpenModal(false);

  //Formik
  const formik = useFormik({
    initialValues: isInModification ? widget[0]?.data || defaultChips : defaultChips,
    enableReinitialize: true,
    onSubmit: values => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  useEffect(() => {
    handleOpen();
  }, []);

  //Gestione chiusura del modal
  function handleClose(event, reason) {
    switch (reason) {
      case 'backdropClick':
        return;
      case 'escapeKeyDown':
        return;
      default:
        setOpenModal(false);
    }
  }

  //DND
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newChips = Array.from(formik.values?.chips);
    const [removed] = newChips?.splice(result?.source?.index, 1);
    newChips?.splice(result?.destination?.index, 0, removed);
    formik.setFieldValue('chips', newChips);
  };

  function addChip() {
    let items = [...formik.values?.chips];
    if (items.length <= maxChips - 1) {
      items.push(
        {
          text: '',
          url: '',
          in_evidence: false,
        }
      );
      formik.setFieldValue('chips', items);
    }
  }

  function removeChip(_index) {
    let items = [...formik.values?.chips];
    if (_index !== -1) {
      items.splice(_index, 1);
      formik.setFieldValue('chips', items);
    }
  }

  return (
    <>
      <Modal
        aria-labelledby="livetag-modal-title"
        aria-describedby="livetag-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      //disableEscapeKeyDown={true} 
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography id="livetag-modal-title" variant="h6" component="h2"
              style={{ marginBottom: "20px" }}>
              {isInModification ? 'Multiple Link Chips' : 'New Multiple Link Chips'}
            </Typography>
            <div className="row d-flex justify-content-center p-3">
              <div className="col-12">
                <span className="fw-bold">Title:</span>
                <input type="text" id="title" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.title}
                />
              </div>
            </div>
            <div id="modal-dnd-set-control" className="row justify-content-center p-3 user-select-none"
              style={{ minHeight: "380px" }}>
              <div className="col-12">
                <span className="fw-bold">Link Chips:</span>
                {(formik.values?.chips?.length > 0) &&
                  (
                    <>
                      <DragDropContext onDragEnd={onDragEnd} >
                        <Droppable droppableId="droppable_fa" >
                          {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                              {formik.values?.chips?.map((chip, index) =>
                              (
                                <Draggable style={{ position: "static !important" }} key={index} draggableId={index.toString()} index={index}>
                                  {(provided, snapshot) => (
                                    <DragItem className="row align-items-center p-0"
                                      // style={{ backgroundColor: (index % 2 === 0) ? 'whitesmoke' : 'white' }}
                                      ref={provided.innerRef}
                                      snapshot={snapshot}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="col-1 text-md-center">
                                        <span style={{ margin: "0 8px 0 0" }}>
                                          <FontAwesomeIcon icon={['fas', 'grip-vertical']} size={'1x'} color={'#198754'}
                                            title="Drag and drop del chip" />
                                        </span>
                                        <span className="fw-bold" >{index + 1}</span>
                                      </div>

                                      <div className="col-4">
                                        <input type="text" id={`chips[${index}].text`} className="form-control mt-1" style={{ width: "100%" }}
                                          placeholder="Text"
                                          onChange={formik.handleChange}
                                          value={formik.values?.chips[index]?.text}
                                        />
                                      </div>
                                      <div className="col-4">
                                        <input type="text" id={`chips[${index}].url`} className="form-control mt-1" style={{ width: "100%" }}
                                          placeholder="URL"
                                          onChange={formik.handleChange}
                                          value={formik.values?.chips[index]?.url}
                                        />
                                      </div>
                                      <div className="col-2">
                                        <input type="checkbox" id={`chips[${index}].in_evidence`} name={`chips[${index}].in_evidence`}
                                          onChange={(event) => { formik.setFieldValue(`chips[${index}].in_evidence`, event.target.checked) }}
                                          checked={formik.values?.chips[index]?.in_evidence ? formik.values?.chips[index]?.in_evidence : false}
                                          style={{ transform: `scale(1.25)` }} />
                                        <label style={{ marginLeft: "8px", fontSize: "14px" }}>In evidenza</label>
                                      </div>

                                      <div className="col-1" style={{ padding: "2px" }}>
                                        <IconButton
                                          onClick={() => { removeChip(index); }}
                                          edge="end" aria-label="delete"
                                          style={{ margin: "2px" }}
                                        >
                                          <FontAwesomeIcon icon={['fas', 'minus']} title="Elimina il chip" size={'1x'} color={'red'} />
                                        </IconButton>

                                      </div>
                                      {provided.placeholder}
                                    </DragItem>
                                  )}
                                </Draggable>
                              ))}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </>
                  )}

                <div className="row" style={{ textAlign: "right" }}>
                  <div className="col-12" style={{ paddingRight: "26px" }}>
                    <>
                      {
                        formik.values?.chips?.length < maxChips
                        && <IconButton onClick={() => { addChip(formik.values?.chips?.length); }} edge="end" aria-label="add">
                          <FontAwesomeIcon
                            icon={['fas', 'plus']}
                            title="Aggiungi un link chip"
                            size={'1x'}
                            color={'#198754'}
                          />
                        </IconButton>
                      }
                    </>
                  </div>
                </div>
              </div>
            </div>


            <div className="row mt-2">
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                  onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                  Chiudi
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-success"
                  style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                  onClick={() => { onUpdate(formik.values, index); handleClose(); }}>
                  Conferma
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}